export function onSubmition(deps) {
  return async (person) => {
    const { saveOnState } = deps.person
    saveOnState(person)
  }
}